import moment, { MomentInput } from 'moment';

export const parseDate = (dateString: string): Date => moment(dateString).toDate();

export const formatDate = (date: MomentInput): string => moment(date).format('YYYYMMDD');

export const formatDateApi = (date: MomentInput): string => moment(date).format('YYYY-MM-DD');

export const formatDateToIsoString = (date: MomentInput): string => moment(date).toISOString();

export const prettyDate = (date: MomentInput): string =>
	date ? moment(date).format('MMMM DD, YYYY') : '';

/** Numbers-only date in the user's locale order (e.g. "10/27/2021" or "27.10.2021"). */
export const prettyDateNumeric = (date: MomentInput): string =>
	date
		? moment(date).toDate().toLocaleDateString(undefined, {
				year: 'numeric',
				month: '2-digit',
				day: '2-digit',
		  })
		: '';

export const prettySize = (bytes: number, separator = '', suffix = ''): string => {
	if (bytes) {
		const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
		const i = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), sizes.length - 1);
		return `${(bytes / 1024 ** i).toFixed(i ? 1 : 0)}${separator}${sizes[i]}${suffix}`;
	}
	return '-'; // 'n/a';
};

export const prettyTime = (seconds: number | undefined | null): string => {
	if (!seconds) return '-';

	const secs = seconds % 60;
	const minutes = Math.floor((seconds % 3600) / 60);
	const hours = Math.floor(seconds / 3600);

	let show = false;
	return [hours, minutes, secs]
		.filter((v) => {
			if (v) show = true;
			return show;
		})
		.map((v) => v.toString().padStart(2, '0'))
		.join(':');
};
